import { render, staticRenderFns } from "./MessagesSent.vue?vue&type=template&id=1548c2cc&scoped=true&"
import script from "./MessagesSent.vue?vue&type=script&lang=js&"
export * from "./MessagesSent.vue?vue&type=script&lang=js&"
import style0 from "./MessagesSent.vue?vue&type=style&index=0&id=1548c2cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1548c2cc",
  null
  
)

export default component.exports